<template>
<tr>
        <td class="align-items-center">
            <b-img  v-bind="mainProps" rounded="circle" alt="Circle image" :src="creatorImage" class="shadow-lg float-left"></b-img>
            <h5 class="font-blue p-1 float-left">
                {{conversation.from.name}} {{conversation.from.lname ? conversation.from.lname : ''}}
            </h5>
        </td>
        <td>
            <router-link :to="'/conversation/' + conversation.conversation_url" class="btn b-orange mt-2 shadown-sm">
                <i class="fas fa-comment"></i>
                Ver Conversación
            </router-link>
        </td>
    
</tr>
</template>
<script>
export default {
    props:{
        conversation: Object
    },
    data() {
        return {
            mainProps: { 
                center: true,
                blankColor: '#FFF', 
                width: 35, 
                height: 35, 
            },
            defaultImage: require('@/assets/profile/user_empty.png')   
        }
    },
    computed: {
        creatorImage(){
            return this.conversation.from.avatar && this.conversation.from.avatar != 'null' ? this.conversation.from.avatar : this.defaultImage
        },
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/buzon/components/Conversation.vue